import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';

import styles from './Button.css';


const colors = {
  'blocked': styles.blocked,
  'blue': styles.blue,
  'broadcasterBlack': styles.broadcasterBlack,
  'disclaimer-blue': styles['disclaimer-blue'],
  'disclaimer-pink': styles['disclaimer-pink'],
  'disclaimer-purple': styles['disclaimer-purple'],
  'disclaimer-orange': styles['disclaimer-orange'],
  'info': styles.info,
  'link': styles.link,
  'orange': styles.orange,
  'red': styles.red,
  'green': styles.green,
  'gold': styles.gold,
  'gold-transparent': styles['gold-transparent'],
  'transparent': styles.transparent,
  'upgrade-black': styles['upgrade-black'],
  'upgrade-green': styles['upgrade-green'],
  'white': styles.white,
};

const sizes = {
  'xsmall': styles.xsmall,
  'small': styles.small,
  'large': styles.large,
};

const Button = (props) => {
  const {
    className,
    colour,
    icon,
    label,
    link,
    size,
    ...rest
  } = props;

  const classes = classNames(
    styles.button,
    colors[colour],
    sizes[size],
    className
  );

  const button = (
    <button className={classes} {...rest}>
      {icon}
      {label}
      {props.children}
    </button>
  );

  if (!link) {
    return button;
  }

  return (
    <Link to={link}>
      {button}
    </Link>
  );
};

Button.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  colour: PropTypes.oneOf(Object.keys(colors)),
  disabled: PropTypes.bool,
  icon: PropTypes.node,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.number]),
  link: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.func]),
  size: PropTypes.oneOf(Object.keys(sizes)),
};

Button.defaultProps = {
  children: null,
  className: '',
  colour: 'white',
  disabled: false,
  icon: null,
  label: '',
  link: undefined,
  size: undefined,
};

export default React.memo(Button);
